import React from 'react';
import { EventCard } from './EventCard';
const daysOfWeek = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
// Mock data for demonstration
const events = [{
  id: 1,
  date: 'JAN 23',
  dayIndex: 4,
  title: 'AFTER HOURS',
  artist: 'NOMADIQ',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=1000&auto=format&fit=crop',
  type: 'FRIDAY, JAN 23'
}, {
  id: 2,
  date: 'JAN 24',
  dayIndex: 5,
  title: 'AFTER HOURS',
  artist: 'DJ NINO',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1571266028243-371695039989?q=80&w=1000&auto=format&fit=crop',
  type: 'SATURDAY, JAN 24'
}, {
  id: 3,
  date: 'JAN 25',
  dayIndex: 6,
  title: 'INDUSTRY SUNDAY',
  artist: 'DJ KILOO',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1598387993441-a364f854c3e1?q=80&w=1000&auto=format&fit=crop',
  type: 'JAN 25'
}, {
  id: 4,
  date: 'JAN 29',
  dayIndex: 3,
  title: "DRINK DANCE DRAI'S",
  artist: 'DJ MARX',
  time: '10PM',
  image: 'https://images.unsplash.com/photo-1533174072545-e8d4aa97edf9?q=80&w=1000&auto=format&fit=crop',
  type: 'THURSDAY, JAN 29'
}, {
  id: 5,
  date: 'JAN 30',
  dayIndex: 4,
  title: 'AFTER HOURS',
  artist: 'DJ POUN',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=1000&auto=format&fit=crop',
  type: 'FRIDAY, JAN 30'
}, {
  id: 6,
  date: 'JAN 31',
  dayIndex: 5,
  title: 'AFTER HOURS',
  artist: 'DJ ROMEO',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=80&w=1000&auto=format&fit=crop',
  type: 'SATURDAY, JAN 31'
}, {
  id: 7,
  date: 'FEB 1',
  dayIndex: 6,
  title: 'INDUSTRY SUNDAY',
  artist: 'GUEST DJ',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1514525253440-b393452e8d26?q=80&w=1000&auto=format&fit=crop',
  type: 'FEB 1'
}, {
  id: 8,
  date: 'FEB 5',
  dayIndex: 3,
  title: 'LADIES NIGHT',
  artist: 'SPECIAL GUEST',
  time: '10PM',
  image: 'https://images.unsplash.com/photo-1545128485-c400e7702796?q=80&w=1000&auto=format&fit=crop',
  type: 'ON A THURSDAY'
}, {
  id: 9,
  date: 'FEB 6',
  dayIndex: 4,
  title: 'AFTER HOURS',
  artist: 'RESIDENT DJ',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?q=80&w=1000&auto=format&fit=crop',
  type: 'FRIDAY, FEB 6'
}, {
  id: 10,
  date: 'FEB 7',
  dayIndex: 5,
  title: 'AFTER HOURS',
  artist: 'RESIDENT DJ',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1516280440614-6697288d5d38?q=80&w=1000&auto=format&fit=crop',
  type: 'SATURDAY, FEB 7'
}, {
  id: 11,
  date: 'FEB 8',
  dayIndex: 6,
  title: 'BIG GAME',
  artist: 'WATCH PARTY',
  time: '2PM',
  image: 'https://images.unsplash.com/photo-1518609878373-06d740f60d8b?q=80&w=1000&auto=format&fit=crop',
  type: 'SUNDAY, FEB 8'
}];
// Generate calendar cells (4 weeks)
const generateCalendarCells = () => {
  const cells = [];
  const startDate = new Date(2026, 0, 19); // Jan 19, 2026 (Monday)
  for (let i = 0; i < 28; i++) {
    const currentDate = new Date(startDate);
    currentDate.setDate(startDate.getDate() + i);
    const dateStr = currentDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    }).toUpperCase();
    const event = events.find(e => e.date === dateStr);
    cells.push({
      date: dateStr,
      event: event || null
    });
  }
  return cells;
};
export function CalendarGrid() {
  const cells = generateCalendarCells();
  return <div className="w-full" data-id="element-92">
      {/* Days Header */}
      <div className="grid grid-cols-7 mb-4" data-id="element-93">
        {daysOfWeek.map(day => <div key={day} className="text-center text-xs font-bold text-gray-400 uppercase tracking-widest py-2" data-id="element-94">
            {day}
          </div>)}
      </div>

      {/* Calendar Grid */}
      <div className="grid grid-cols-1 md:grid-cols-7 gap-4" data-id="element-95">
        {cells.map((cell, index) => <div key={index} className="min-h-[300px] flex flex-col" data-id="element-96">
            {cell.event ? <EventCard date={cell.date} title={cell.event.title} artist={cell.event.artist} image={cell.event.image} time={cell.event.time} type={cell.event.type} data-id="element-97" /> : <div className="h-full bg-white/5 border border-white/10 flex flex-col" data-id="element-98">
                <div className="bg-black text-white text-center py-2 text-sm font-bold uppercase tracking-wider border-b border-white/10" data-id="element-99">
                  {cell.date}
                </div>
                <div className="flex-1" data-id="element-100"></div>
              </div>}
          </div>)}
      </div>
    </div>;
}